import { API } from '../../Config'
import { API_GET } from '../../Config'

export const GetProductCategory = () => {
  return (
    API_GET(API.getproductcategory)
  )
}


